import { Api } from './Api';

// Live and Test are separate Stripe Connect applications with different client ids, so the
// account determines which one we onboard against.
export const getClientId = (accountId?: string) => {
  return Api.get('/onboarding/client-id', accountId ? { accountId } : {});
};

export const express = (data: { accountId: string, stripeAuthCode: string }) => {
  return Api.post('/onboarding/express', data);
};